import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MarketplacePricingTierPolicy as PricingPolicy } from '@atlassian/mpac-types/graphql-gateway-types';
import invariant from 'invariant';
import { getTierCeiling } from './PricingCalculatorSection/CloudPricingCalculator/CloudPricingCalculator.utils';
export const CURRENCY_TO_LOCALE = {
  JPY: 'ja-JP',
  USD: 'en-US'
};
export const formatAmount = (amount, options) => {
  const {
    currency,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2
  } = options;
  const locale = CURRENCY_TO_LOCALE[currency] || CURRENCY_TO_LOCALE.USD;
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits,
    maximumFractionDigits
  });
};
export const getTeamSizeLabel = item => item.ceiling ? "".concat(item.ceiling, " users") : "".concat(item.floor, "+ users");

/**
 * Calculate the price of the app for a team of size `users` given a user-tiered per-unit-pricing model.
 * @throws Error when all provided tiers do not cover all `users`.
 */
export const calculatePerUnitPricing = (users, tiers) => {
  const reverseTiers = [...tiers].reverse();
  let amount = 0;
  let remainingUsers = users;
  reverseTiers.forEach(tier => {
    if (remainingUsers >= tier.floor) {
      const usersInTier = remainingUsers - tier.floor + 1;
      const priceForUsersInTier = usersInTier * tier.amount;
      amount += priceForUsersInTier;
      remainingUsers -= usersInTier;
    }
  });
  if (remainingUsers > 0) {
    throw new Error("Available pricing tiers do not cover all users in team of size ".concat(users));
  }
  return amount;
};
export const calculateMonthlyAppCost = (items, numberOfUsers) => {
  const starterTierCeiling = items[0].ceiling;
  invariant(typeof starterTierCeiling === 'number', 'start tier’s ceiling isn’t expected to be unspecified');
  if (numberOfUsers <= starterTierCeiling && items[0].policy === PricingPolicy.Block) return items[0].amount;
  // calculatePerUnitPricing() requires the tiers to be perUnit.
  // This logic removes the Block tier and makes the 1st PUP tier to start from 1
  const perUnitTiers = items.filter(tier => tier.policy === PricingPolicy.PerUnit).map((tier, index) => index === 0 ? _objectSpread(_objectSpread({}, tier), {}, {
    floor: 1
  }) : tier);
  return calculatePerUnitPricing(numberOfUsers, perUnitTiers);
};
export const getPricingTier = (items, userCount) => {
  // If the input is 0, we take the first tier
  if (userCount === 0) return items[0];
  const lastTier = items[items.length - 1];
  const lastTierCeiling = getTierCeiling(lastTier);
  if (userCount > lastTierCeiling) return lastTier;
  const tier = items.find(item => {
    const itemCeiling = getTierCeiling(item);
    return item.floor <= userCount && itemCeiling >= userCount;
  });
  invariant(tier, 'Tier is always found because the input is always positive');
  return tier;
};